import { useTranslation } from 'react-i18next';
import { useFinalizeNewBusinessRules } from './useFinalizeNewBusinessRules';
import { CheckSquareIcon, SquareIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@folio/components';
import dompurify from 'dompurify';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { FinalizeNewBusinessActions } from './FinalizeNewBusinessActions';
import { Stack } from '@folio/components/ui/flex';

export function FinalizeNewBusinessCard() {
  const { t } = useTranslation();

  const { policy, policyOnMain } = usePolicyOnDashboard();

  const rules = useFinalizeNewBusinessRules();

  if (!rules || policyOnMain.status !== 'POLICY_CREATED') {
    return null;
  }

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>{t('finalizeNewBusiness.action')}</CardTitle>
          <FinalizeNewBusinessActions />
        </CardHeader>
        <Stack asChild>
          <CardContent>
            <div
              className="text-sm"
              dangerouslySetInnerHTML={{
                __html: dompurify.sanitize(
                  t([
                    `${policy.productId}.finalizeNewBusiness.description`,
                    'finalizeNewBusiness.description',
                  ]),
                ),
              }}
            />
            <Stack asChild>
              <ul>
                {rules.map(({ label, isValid, link }) => (
                  <li key={label} className="flex items-center space-x-2 text-sm">
                    {isValid ? <CheckSquareIcon /> : <SquareIcon />}
                    {link ? (
                      <Link to={link} className="underline">
                        {label}
                      </Link>
                    ) : (
                      <span>{label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </Stack>
          </CardContent>
        </Stack>
      </Card>
    </>
  );
}
